<div class="docviewer-bottom">
    <ngx-extended-pdf-viewer [src]="module?.blob" [height]="height" [useBrowserLocale]="true"
        [showDownloadButton]="config?.showDownloadButton" [showPrintButton]="config?.showPrintButton"
        [showOpenFileButton]="config?.showOpenFileButton" [showSidebarButton]="config?.showSidebarButton"
        [showBookmarkButton]="config?.showBookmarkButton"
        [showSecondaryToolbarButton]="config?.showSecondaryToolbarButton"
        [showPresentationModeButton]="config?.showPresentationModeButton" #pdfViewer>
    </ngx-extended-pdf-viewer>
</div>